export function convertToSeconds(ms: number): number {
  return ms / 1000;
}
